import { useContext } from "react";
import { ColorModeContext } from "./../context/ColorModeContextProvider";

export default function useColorMode() {
  const options = useContext(ColorModeContext);
  return options;
}
